<template>
  <div class="step-dialog" :class="status.in?'animate__animated animate__zoomIn':'animate__animated animate__zoomOut'">
    <div class="step">
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-1s">
        <div class="step-dialog-item">
          <div class="start">
            开始
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-1100ms">
        <div class="step-dialog-item step-dialog-item-arrow">
          <div class="arrow">
            <div class="one">
              数据调查
            </div>
            <div class="two"></div>
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-1200ms">
        <div class="step-dialog-item">
          <div class="source">
            <div class="source-item">
              调查消费力
            </div>
            <div class="source-item">
              调查总销量
            </div>
            <div class="source-item">
              调查卖家量
            </div>
            <div class="source-item">
              调查评论数
            </div>
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-1300ms">
        <div class="step-dialog-item step-dialog-item-arrow">
          <div class="arrow">
            <div class="one">
              同步生成数据
            </div>
            <div class="two"></div>
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-1400ms">
        <div class="step-dialog-item">
          <div class="generation">
            <div class="source-item">
              马来西亚
            </div>
            <div class="source-item">
              泰国
            </div>
            <div class="source-item">
              越南
            </div>
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-1500ms">
        <div class="step-dialog-item step-dialog-item-arrow">
          <div class="arrow">
            <div class="one">
              对比分析
            </div>
            <div class="two"></div>
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-1600ms">
        <div class="step-dialog-item">
          <div class="comparision">
            <div class="source-item">
              正山小种
            </div>
            <div class="source-item">
              大红袍
            </div>
            <div class="source-item">
              茉莉花
            </div>
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-1700ms">
        <div class="step-dialog-item step-dialog-item-arrow">
          <div class="arrow">
            <div class="one">
              编辑产品
            </div>
            <div class="two"></div>
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-1800ms">
        <div class="step-dialog-item">
          <div class="edit">
            <div class="source-item">
              标题
            </div>
            <div class="source-item">
              定价
            </div>
            <div class="source-item">
              库存
            </div>
            <div class="source-item">
              描述
            </div>
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-1900ms">
        <div class="step-dialog-item step-dialog-item-arrow">
          <div class="arrow">
            <div class="one">
              产品上架
            </div>
            <div class="two"></div>
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-2000ms">
        <div class="step-dialog-item">
          <div class="result">
            <div class="source-item">
              实验目的
            </div>
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-2100ms">
        <div class="step-dialog-item step-dialog-item-arrow">
          <div class="arrow">
            <div class="one">
              提交报告
            </div>
            <div class="two"></div>
          </div>
        </div>
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-2200ms">
        <div class="step-dialog-item step-dialog-item-end">
          <div class="end ">
            结束
          </div>
        </div>
      </transition>
    </div>
    <transition appear appear-to-class="animate__animated animate__fadeIn animate__delay-3s">
      <div class="close" @click="close">
        关闭
      </div>
    </transition>
    <canvas id="canvas"></canvas>
  </div>
</template>

<script>
  export default {
    name: "stepDialog",
    props: [
      'status'
    ],
    data() {
      return {}
    },
    mounted() {
      const doms = Array.from(document.querySelectorAll('.step-dialog-item'))
      setTimeout(() => {
        doms.slice(this.status.start, this.status.end).forEach(item => {
          this.animateCss(item, 'flash', 'animate__repeat-2', 'active')
        })
      }, this.status.delayTime ? parseFloat(3000 + this.status.delayTime) : 3000)
      var canvas = document.getElementById('canvas'),
        ctx = canvas.getContext('2d'),
        w = canvas.width = window.innerWidth,
        h = canvas.height = window.innerHeight,
        
        hue = 217,
        stars = [],
        count = 0,
        maxStars = 800;//星星数量
      
      var canvas2 = document.createElement('canvas'),
        ctx2 = canvas2.getContext('2d');
      canvas2.width = 100;
      canvas2.height = 100;
      var half = canvas2.width / 2,
        gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half);
      gradient2.addColorStop(0.025, '#CCC');
      gradient2.addColorStop(0.1, 'hsl(' + hue + ', 61%, 33%)');
      gradient2.addColorStop(0.25, 'hsl(' + hue + ', 64%, 6%)');
      gradient2.addColorStop(1, 'transparent');
      
      ctx2.fillStyle = gradient2;
      ctx2.beginPath();
      ctx2.arc(half, half, half, 0, Math.PI * 2);
      ctx2.fill();
      ctx.globalAlpha=0.2;

// End cache
      
      function random(min, max) {
        if (arguments.length < 2) {
          max = min;
          min = 0;
        }
        
        if (min > max) {
          var hold = max;
          max = min;
          min = hold;
        }
        
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }
      
      function maxOrbit(x, y) {
        var max = Math.max(x, y),
          diameter = Math.round(Math.sqrt(max * max + max * max));
        return diameter / 2;
        //星星移动范围，值越大范围越小，
      }
      
      var Star = function () {
        
        this.orbitRadius = random(maxOrbit(w, h));
        this.radius = random(60, this.orbitRadius) / 8;
        //星星大小
        this.orbitX = w / 2;
        this.orbitY = h / 2;
        this.timePassed = random(0, maxStars);
        this.speed = random(this.orbitRadius) / 50000;
        //星星移动速度
        this.alpha = random(2, 10) / 10;
        
        count++;
        stars[count] = this;
      }
      
      Star.prototype.draw = function () {
        var x = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX,
          y = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY,
          twinkle = random(10);
        
        if (twinkle === 1 && this.alpha > 0) {
          this.alpha -= 0.05;
        } else if (twinkle === 2 && this.alpha < 1) {
          this.alpha += 0.05;
        }
        
        ctx.globalAlpha = this.alpha;
        ctx.drawImage(canvas2, x - this.radius / 2, y - this.radius / 2, this.radius, this.radius);
        this.timePassed += this.speed;
      }
      
      for (var i = 0; i < maxStars; i++) {
        new Star();
      }
      
      function animation() {
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 0.5; //尾巴
        ctx.fillStyle = 'hsla(' + hue + ', 64%, 6%, 2)';
        ctx.fillRect(0, 0, w, h)
        
        ctx.globalCompositeOperation = 'lighter';
        for (var i = 1, l = stars.length; i < l; i++) {
          stars[i].draw();
        }
        
        window.requestAnimationFrame(animation);
      }
      
      animation();
    },
    methods:{
      close(){
        this.$emit('close')
        localStorage.setItem(this.status.page,true)
      }
    }
  }
</script>

<style scoped lang="scss">
  .step-dialog {
    z-index: 999;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    
    #canvas {
      position: absolute;
      z-index: 998;
    }
    
    .close {
      cursor: pointer;
      position: absolute;
      z-index: 999;
      width: 150px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 18px;
      color: #FFFFFF;
      left: calc(50% - 75px);
      bottom: 20%;
      text-decoration: none;
      border: 1px solid rgb(146, 148, 248);
      overflow: hidden;
      border-radius:100px;
      &:hover {
        box-shadow: 1px 1px 25px 10px rgba(146, 148, 248, 0.4);
      }
  
      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
                120deg,
                transparent,
                rgba(146, 148, 248, 0.4),
                transparent
        );
        transition: all 650ms;
      }
  
      &:hover:before {
        left: 100%;
      }
    }
    
    
    &.show {
      z-index: 999;
    }
    
    .step {
      position: absolute;
      z-index: 999;
      display: flex;
      align-items: center;
      
      
      .step-dialog-item {
        margin: 0 10px;
        display: flex;
        align-items: center;
        
        
        &.active:not(.step-dialog-item-arrow) {
          box-shadow: 0px 0px 40px 0px #ffffff;
          overflow: hidden;
          border-top-left-radius: 10px 10px;
          border-bottom-left-radius: 10px 10px;
          border-top-right-radius: 10px 10px;
          border-bottom-right-radius: 10px 10px;
        }
        
        &.active.step-dialog-item-end {
          border-top-left-radius: 30px 30px;
          border-bottom-left-radius: 30px 30px;
          border-top-right-radius: 30px 30px;
          border-bottom-right-radius: 30px 30px;
        }
        
        &.active.step-dialog-item-arrow {
          .one {
            box-shadow: 20px 0px 30px 6px #ffffff;
          }
        }
        
        .start {
          width: 60px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          border-radius: 50%;
          background: #FE4A49;
          color: #FFFFFF;
          font-size: 14px;
        }
        
        .end {
          width: 60px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          border-radius: 50%;
          background: #3b322f;
          color: #FFFFFF;
          font-size: 14px;
        }
        
        .source {
          padding: 10px;
          border-radius: 10px;
          background: #6096e6;
          
          .source-item {
            border: 1px solid #FFFFFF;
            padding: 10px;
            margin-bottom: 6px;
            color: #FFFFFF;
            
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        
        .generation {
          padding: 10px;
          border-radius: 10px;
          background: #ffba55;
          
          .source-item {
            border: 1px solid #FFFFFF;
            padding: 10px;
            margin-bottom: 6px;
            color: #FFFFFF;
            
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        
        .comparision {
          padding: 10px;
          border-radius: 10px;
          background: #156389;
          
          .source-item {
            border: 1px solid #FFFFFF;
            padding: 10px;
            margin-bottom: 6px;
            color: #FFFFFF;
            
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        
        .edit {
          padding: 10px;
          border-radius: 10px;
          background: #ff5722;
          
          .source-item {
            border: 1px solid #FFFFFF;
            padding: 10px;
            margin-bottom: 6px;
            color: #FFFFFF;
            
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        
        .result {
          padding: 10px;
          border-radius: 10px;
          background: #005BE7;
          
          .source-item {
            border: 1px solid #FFFFFF;
            padding: 10px;
            margin-bottom: 6px;
            color: #FFFFFF;
            
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        
        .arrow {
          display: flex;
          align-items: center;
          
          .one {
            width: 80px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #cacaca;
            font-weight: bolder;
          }
          
          .two {
            border-left: 50px solid #cacaca;
            border-right: 0px solid transparent;
            border-top: 26px solid transparent;
            border-bottom: 26px solid transparent;
          }
        }
        
      }
      
    }
  }
</style>
